import { createAction, createReducer } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { BillingStore, Plan } from './types'

// ---
// Action creators
// ---
export const actions = {
  setYearlyOfferPlan: createAction<Plan>('builder/BILLING_SET_YEARLY_OFFER_PLAN'),
  fetchYearlyOfferPlan: createAction('builder/BILLING_FETCH_YEARLY_OFFER_PLAN'),
}

// ---
// Selectors
// ---
export const selectors = {
  yearlyOfferPlan: (state: Store) => state.billingReducer.yearlyOfferPlan,
}

// ---
// Reducer
// ---
const initialState: BillingStore = {
  yearlyOfferPlan: null,
}

export const reducer = createReducer(initialState, reducer => {
  reducer.addCase(actions.setYearlyOfferPlan, (draft, action) => {
    draft.yearlyOfferPlan = action.payload
  })
})
